/* eslint-disable max-len */
export default {
  ACTIONS: {
    HOME: 'Start',
    LOGOUT: 'Abmelden',
    NEXT: 'Weiter',
    SUBMIT: 'Senden',
    USERS: 'Benutzer'
  },
  ERRORS: {
    BASE:
      'Etwas ist schief gelaufen… Es tut uns leid! Versuche es in einigen Minuten erneut. 🥴'
  },
  MESSAGES: {
    NOT_FOUND: 'Seite nicht gefunden',
    ORDER: 'Bestellung',
    OTHER: 'Andere',
    OTHER_RET: 'Andere...',
    PROZIS_NOW: 'PROZIS NOW',
    UNAUTHORIZED: 'Du hast keinen Zugriff'
  },
  SENTENCES: {
    NOT_FOUND: 'Leider konnten wir nicht finden, wonach du suchst.',
    UNAUTHORIZED:
      'Du hast leider keinen Zugriff. Wenn du Zugriff benötigst, kontaktiere uns bitte.'
  }
};
